import { faClose } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  FontAwesomeIconStyled,
  StepHeaderLabelStyled,
  StepHeaderStyled,
  StepperBoxIn,
  StepperBoxOut,
} from './TrlOuterModal.styled';

export const TrlOuterModal = ({
  children,
  title,
  handleClose,
  innerBackgroundColor,
  isNewsModal,
}) => (
  <StepperBoxOut isNewsModal={isNewsModal}>
    <StepHeaderStyled isNewsModal={isNewsModal}>
      <StepHeaderLabelStyled isNewsModal={isNewsModal}>
        <FormattedMessage id={title} />
      </StepHeaderLabelStyled>
      <FontAwesomeIconStyled icon={faClose} onClick={handleClose} />
    </StepHeaderStyled>
    <StepperBoxIn
      backgroundColor={innerBackgroundColor}
      isNewsModal={isNewsModal}
    >
      {children}
    </StepperBoxIn>
  </StepperBoxOut>
);

TrlOuterModal.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  innerBackgroundColor: PropTypes.string,
  isNewsModal: PropTypes.bool,
};
